import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsPRR, batteryTabsEcoPRR } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialPRR,
  getChecklistEcoPRR
} from "helpers/ChecklistBatteryHelper";

const RequestContentPRR = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialPRR(request);
  const checkListECO = getChecklistEcoPRR(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsPRR}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsEcoPRR}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentPRR);
